import React, {useCallback, useEffect, useState} from "react";
import Headeraccount from "../Headeraccount";
import Footer from "../Footer";
import NavbarHB from "../NavbarHB";
import Navigation from "../Navigation";
import {Button, Checkbox, FilePicker, Select, Table, TextBox, ThemeProvider,} from "@veneer/core";
import {roles} from "../utils/roles";
import EncodingService from "../api/encoding/EncodingService";
import {Modal} from "react-bootstrap";
import brand from "@veneer/hp-brand";
import {showToast} from "../components/Toast";
import {AUTHENTICATED, removeLocalStorageItem} from "../utils/storage-utils";

const SWCatalogUpload = (props) => {
  const tabsEnabledStatus = "FULL";

  const [selectedFile, setSelectedFile] = useState("");
  const [uploadingStatus, setUploadingStatus] = useState(false);
  const [spinnerLoadingStatus, setSpinnerLoadingStatus] = useState(false);
  const [uploadSWResult, setUploadSWResult] = useState([]);
  const [uploadSWResultColor, setUploadSWResultColor] = useState("");
  const [uploadSWSuccess, setUploadSWSuccess] = useState(false);
  const [preSignedURLs, setPreSignedURLs] = useState([]);
  const [softwareTable, setSoftwareTable] = useState([]);
  const [softwareFileIdArr, setSoftwareFileIdArr] = useState([]);
  const [selectedSoftwareFileDrop, setSelectedSoftwareFileDrop] = useState([]);
  const [selectedSoftware, setSelectedSoftware] = useState("");
  const [softwareName, setSoftwareName] = useState("");
  const [hasSignature, setHasSignature] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addSoftwareResult, setAddSoftwareResult] = useState([]);
  const [addSoftwareSuccess, setAddSoftwareSuccess] = useState(false);
  const [softwareIdValue, setSoftwareIdValue] = useState("");
  const [fileIdToDel, setFileIdToDel] = useState([]);
  const [delMsg, setDelMsg] = useState([]);
  const [softwareNameError, setSoftwareNameError] = useState(false);
  const [filePickerError, setFilePickerError] = useState(false);
  const [publicKeyPickerError, setPublicKeyPickerError] = useState(false);
  const [signaturePickerError, setSignaturePickerError] = useState(false);
  const [navValue, setNavValue] = useState(null);
  const [softwareFileNameErrorText, setSoftwareFileNameErrorText] = useState("");
  const [publicKeyFileNameErrorText, setPublicKeyFileNameErrorText] = useState("");
  const [signatureFileNameErrorText, setSignatureFileNameErrorText] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);
  const [fileSelectedDrop, setFileSelectedDrop] = useState([])
  const [signatureFile,setSignatureFile] = useState("")
  const [publicKeyFile,setPublicKeyFile] = useState("")

  let role = props.role;

  const navbarSwitch = useCallback(() => {

    if (role !== roles.hbAdministrator) {
      setNavValue(
          <Navigation tabsEnabledStatus={tabsEnabledStatus} role={role} />
      );
    }

    if (role === roles.hbAdministrator) {
      setNavValue(<NavbarHB role={role} />);
    }
  }, [role]);

  const postingToS3 = useCallback(async () => {
    let softwareIdToString = softwareIdValue.toString();
    if (preSignedURLs) {
      console.log(preSignedURLs)
      const files = [selectedFile, publicKeyFile, signatureFile]
      let uploadRes = await pushFileToS3(preSignedURLs, files);
      if (uploadRes) {
        await EncodingService.postSWFileUploadCheck(
            softwareIdToString,
            selectedFile.name,
            signatureFile.name,
            publicKeyFile.name
        ).then(
            () => {
              setUploadSWSuccess(true);
              setUploadSWResultColor('#024ad8');
              setUploadSWResult(["File " + selectedFile.name + " added successfully", ""]);
            },
            (error) => {
              let arr = error.response.data.message.split(":", 2);
              setUploadSWSuccess(false);
              setUploadSWResultColor(brand.color.red);
              setUploadSWResult(arr);
            }
        );
      } else {
        setUploadSWSuccess(false);
        setUploadSWResultColor(brand.color.red);
        setUploadSWResult(["File Upload Failed", ""]);
      }
    } else {
      setUploadSWSuccess(false);
      setUploadSWResultColor(brand.color.red);
      setUploadSWResult(["File Upload failed as PreSigned URL is not present", ""]);
    }
    getSoftwareFunction();
    setPublicKeyFile("");
    setPublicKeyPickerError(false)
    setPublicKeyFileNameErrorText("");
    setSignatureFile("");
    setSignaturePickerError(false);
    setSignatureFileNameErrorText("");
    setSelectedSoftware("");
    setSelectedFile("");
    setUploadingStatus(false);
    setSpinnerLoadingStatus(false);
    setPreSignedURLs([]);
  }, [preSignedURLs, softwareIdValue]);

  useEffect(() => {
    getSoftwareFunction();
    navbarSwitch();
  }, [navbarSwitch]);

  useEffect(() => {
    validateAndHandleSecondaryFiles();
  }, [selectedFile, signatureFile, publicKeyFile]);

  useEffect(() => {
    if(addSoftwareResult[0]) {
      showToast(<div><p>{addSoftwareResult[0]}</p><p>{addSoftwareResult[1]}</p></div>, addSoftwareSuccess ? 'success' : 'error')
    }
    if (addSoftwareSuccess === true) {
      const timer = setTimeout(() => {
        setAddSoftwareResult([]);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [addSoftwareSuccess, addSoftwareResult]);

  useEffect( () => {
    const fetchSoftwareFiles = async()=>{
      if (preSignedURLs.length !== 0) {
        await postingToS3();
      }
    }
    fetchSoftwareFiles();
  }, [preSignedURLs, postingToS3]);

  useEffect(() => {
    if(uploadSWResult[0]) {
      showToast(<div><p>{uploadSWResult[0]}</p><p>{uploadSWResult[1]}</p></div>, uploadSWResultColor === ('#024ad8') ? 'success' : 'error')
    }
    if (uploadSWSuccess === true) {
      const timer = setTimeout(() => {
        setUploadSWResultColor("");
        setUploadSWResult([]);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [uploadSWSuccess, uploadSWResult]);

  const getSoftwareFunction = () => {
    EncodingService.getSoftwareCatalogList().then((res) => {
      let dbSoftwareTableData = [];

      res?.data?.forEach((item) => {
        let obj = {
          id: item.id,
          name: item.name,
          software: item.software,
          signed: item.software.length > 0 ? item.software[0].public_key_fileName != null && item.software[0].signature_fileName != null : false,
        };
        dbSoftwareTableData.push(obj);
      });
      setSoftwareTable(dbSoftwareTableData);
      setLoading(false);
      let swFileIdArr = [];
      let fileSelectArr = [];
      for (let i = 0; i < dbSoftwareTableData.length; i++) {
        if (dbSoftwareTableData[i].software.length !== 0) {
          for (let j = 0; j < dbSoftwareTableData[i].software.length; j++) {
            if (dbSoftwareTableData[i].software[j].active === true) {
              swFileIdArr.push(dbSoftwareTableData[i].software[j].id);
              fileSelectArr.push(dbSoftwareTableData[i].software[j].name);
            }
          }
        } else {
          swFileIdArr.push(null);
          fileSelectArr.push(null);
        }
      }

      setSoftwareFileIdArr(swFileIdArr);
      setSelectedSoftwareFileDrop(fileSelectArr);
    }).catch(()=>{
      removeLocalStorageItem(AUTHENTICATED);
      window.location.href ="/supplyencodingsvc/?state=Error";
    });
  };

  const changeSoftwareName = (e) => {
    setSelectedSoftware("");
    setSelectedFile("");
    setFilePickerError(false);
    setSoftwareFileNameErrorText("");
    setUploadSWResultColor("");
    setUploadSWResult([]);
    setSoftwareName(e);
  };

  const addButton = () => {
    setSelectedSoftware("");
    setSelectedFile("");
    setFilePickerError(false);
    setSoftwareFileNameErrorText("");
    setUploadSWResultColor("");
    setUploadSWResult([]);
    const SoftwareNameRegex = "^(?![-_. ])[a-zA-Z0-9-_. ]{1,255}(?<![-_. ])$";

    let softwareNameData = {
      name: softwareName,
    };
    if (softwareName === "") {
      setSoftwareNameError(true);
      setAddSoftwareSuccess(false);
      setAddSoftwareResult(["Please Enter Software Name ", ""]);
    } else if (!softwareName.match(SoftwareNameRegex)) {
      setSoftwareNameError(true);
      setAddSoftwareSuccess(false);
      setAddSoftwareResult(["Not a valid Software Name ", ""]);
    }  else {
      setSoftwareNameError(false);
      EncodingService.addSoftware(softwareNameData).then(
          () => {
            showToast(`software ${softwareName}  added successfully`, 'success')
            setSoftwareName("");
            pageSize===softwareTable.length-1 && setPageSize(softwareTable.length)
            getSoftwareFunction();
          },
          (error) => {
            showToast(error?.response ? error.response.data.message ? error.response.data.message : 'Internal server error' : 'error' )
          }
      );
    }
  };

  const selectSoftwareChange = (e) => {
    setSoftwareName("");
    setSoftwareNameError(false);
    setAddSoftwareSuccess(false);
    setAddSoftwareResult([]);
    setSelectedSoftware(e.value);
    setSoftwareIdValue(e.id);
    setHasSignature(false);
  };

  const onHasSignatureChange = () => {
    setHasSignature(!hasSignature);
  }

  const onChangePublicKey = (event) => {
    setPublicKeyFile(event.target.files[0]);
  }
  const onChangeSignatureFile=(event)=>{
    setSignatureFile(event.target.files[0]);
  }
  const validateAndHandleSecondaryFiles = () =>{

    setPublicKeyPickerError(false);
    setPublicKeyFileNameErrorText("");
    setSignaturePickerError(false);
    setSignatureFileNameErrorText("");
    console.log(selectedFile?.name, publicKeyFile?.name, signatureFile?.name);
    if (selectedFile && publicKeyFile && signatureFile) {
      const primaryFileName = selectedFile.name.toLowerCase()
      const sigFileName = signatureFile.name.toLowerCase()
      const pkFileName = publicKeyFile.name.toLowerCase()
      console.log(primaryFileName, sigFileName, pkFileName);
      const sigValid = sigFileName.replace(".asc", "") === primaryFileName;
      if (!sigValid) {
        setSignaturePickerError(true);
        setSignatureFileNameErrorText("Invalid signature file name. Signature file name " + primaryFileName + ".asc");
      } else {
        setSignaturePickerError(false);
        setSignatureFileNameErrorText("");
      }
      const pkValid = pkFileName.replace(".pub", "") === primaryFileName;
      if (!pkValid) {
          setPublicKeyPickerError(true);
          setPublicKeyFileNameErrorText("Invalid public key file name. Public key file name " + primaryFileName + ".pub");
      } else {
          setPublicKeyPickerError(false);
          setPublicKeyFileNameErrorText("");
      }
    }
  }

  const onChangeFileHandler = (event) => {
    setSoftwareName("");
    setSoftwareNameError(false);
    setAddSoftwareSuccess(false);
    setAddSoftwareResult([]);
    let fileName = event.target.files[0].name;
    const softwareFileNameRegex = "^[0-9a-zA-Z]+(([-_.]+?[0-9a-zA-Z]+)+)?.zip$";

    if (fileName.toLowerCase().slice(fileName.length - 4) !== ".zip" ) {
      setSelectedFile("");
      setFilePickerError(true);
      setSoftwareFileNameErrorText("Invalid file type.");
      setUploadSWResultColor("");
      setUploadSWResult([]);
    } else if (fileName.toLowerCase().match(softwareFileNameRegex) === null) {
      setSelectedFile("");
      setFilePickerError(true);
      setUploadSWResultColor(brand.color.red);
      setUploadSWResult(["Invalid file name. Allowed special characters are - _ . and file name must not start or end with a special character.", ""]);
      setSoftwareFileNameErrorText("");
    } else if (fileName.length > 255) {
      setSelectedFile("");
      setFilePickerError(true);
      setUploadSWResultColor(brand.color.red);
      setUploadSWResult(["Invalid file name. File name exceeded the limit (255 characters).", ""]);
      setSoftwareFileNameErrorText("");
    } else {
      setSelectedFile(event.target.files[0]);
      setFilePickerError(false);
      setSoftwareFileNameErrorText("");
      setUploadSWResultColor("");
      setUploadSWResult([]);
    }
  };

  const getS3PreSignedURLs = async () => {
    await EncodingService.getPreSignedURLs(selectedFile.name, publicKeyFile.name, signatureFile.name).then((res) => {
      setPreSignedURLs(res?.data);
    });
  };

  const pushFileToS3 = async (preSignedURLs, allFiles) => {
    const response =   await Promise.all(
      preSignedURLs.map((url, index) => {

        let data = allFiles[index];
        return fetch(url.message, {
          method: "PUT",
          body: data,
        })
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
              }
              return res;
            })
            .catch((error) => {
              // Return a rejected promise with a custom error object
              return Promise.reject({ success: false, error: error.message });
            });
      })
    );

    const results = response.filter(Boolean);
    return results.every((status) => status.status === 200);
  };

  const onFileUpload = async () => {
    setSoftwareName("");
    setSoftwareNameError(false);
    setAddSoftwareSuccess(false);
    setAddSoftwareResult([]);
    setUploadingStatus(true);
    setSpinnerLoadingStatus(true);
    let softwareFilesList = softwareTable.map((sw) => {
      return sw.software.map((swFile) => swFile.name);
    });
    let swFilArr = softwareFilesList.flat(1);
    if (swFilArr.includes(selectedFile.name)) {
      setUploadSWSuccess(false);
      setUploadSWResultColor(brand.color.red);
      setUploadSWResult(["Duplicate software file", "Identical software file already exists. Please delete the existing file and upload again."]);
      setUploadingStatus(false);
      setSpinnerLoadingStatus(false);
      setSelectedSoftware("");
      setSelectedFile("");
      setSignatureFile("");
      setPublicKeyFile("");
    } else {
      await getS3PreSignedURLs();
    }
  };

  const selectedSWFileDropChange = (e, i) => {
    setFileSelectedDrop([e.value])
    let swFileSelectArr = selectedSoftwareFileDrop;
    let swFileIdArr = softwareFileIdArr;
    swFileSelectArr[i] = e.value;
    swFileIdArr[i] = e.id;
    setSelectedSoftwareFileDrop(swFileSelectArr);
    setSoftwareFileIdArr(swFileIdArr);

    EncodingService.updateSoftwareFileAsActive(e.softwareId, e.id).then(
        () => {
          getSoftwareFunction();
        },
        (error) => {
          let arr = error.response.data.message.split(":", 2);
          showToast(<div><p>{arr[0]}</p><p>{arr[1]}</p></div>, 'error')
        }
    );
  };

  const displaySize = (i) => {
    let idArr = softwareFileIdArr;
    let sizeArr = [];
    for (let i = 0; i < softwareTable.length; i++) {
      if (softwareTable[i].software.length > 0) {
        for (let j = 0; j < softwareTable[i].software.length; j++) {
          if (softwareTable[i].software[j].id === idArr[i]) {
            sizeArr.push(softwareTable[i].software[j].size);
          }
        }
      } else {
        sizeArr.push(null);
      }
    }
    return sizeArr[i];
  };

  const displaySigned = (i) => {
    let idArr = softwareFileIdArr;
    let sigArr = [];
    for (let i = 0; i < softwareTable.length; i++) {
      if (softwareTable[i].software.length > 0) {
        for (let j = 0; j < softwareTable[i].software.length; j++) {
          if (softwareTable[i].software[j].id === idArr[i]) {
            sigArr.push(
                  (softwareTable[i].software[j].public_key_fileName != null &&
                      softwareTable[i].software[j].public_key_fileName.trim().length > 0 &&
                      softwareTable[i].software[j].signature_fileName != null &&
                      softwareTable[i].software[j].signature_fileName.trim().length > 0) ? 'Yes' : 'No');
          }
        }
      } else {
        sigArr.push(null);
      }
    }

    return sigArr[i]
  };

  const deleteFunction = (softwareId, i) => {
    let num = [];
    num[0] = softwareId;
    num[1] = i;
    let msg = [];

    if (softwareTable[i].software.length !== 0) {
      msg[0] =
          "Are you sure you want to permanently delete this software file?";
      msg[1] = selectedSoftwareFileDrop[i];
      setDelMsg(msg);
    } else {
      msg[0] = "Are you sure you want to permanently delete this Software?";
      msg[1] = softwareTable[i].name;
      setDelMsg(msg);
    }

    setFileIdToDel(num);
    setShowModal(true);
  };

  const delFileFunc = () => {
    let swIndex = fileIdToDel[1];
    let softwareId = fileIdToDel[0];
    setBtnLoading(true);
    if (softwareTable[swIndex].software.length !== 0) {
      EncodingService.delSoftwareFile(softwareFileIdArr[swIndex]).then(
          () => {
            setBtnLoading(false);
            getSoftwareFunction();
            setFileSelectedDrop([])
            setShowModal(false);
            showToast(<p>Software File has been deleted.</p>, 'success')
          },
          (error) => {
            setShowModal(false);
            setBtnLoading(false);
            let arr = error.response.data.message.split(":", 2);
            showToast(<div><p>{arr[0]}</p><p>{arr[1]}</p></div>, 'error')
          }
      );
    } else {
      EncodingService.delSoftware(softwareId).then(
          () => {
            setShowModal(false);
            getSoftwareFunction();
            setBtnLoading(false);
            showToast(<p>Software has been deleted.</p>, 'success')
          },
          (error) => {
            setShowModal(false);
            setBtnLoading(false);
            let arr = error.response.data.message.split(":", 2);
            showToast(<div><p>{arr[0]}</p><p>{arr[1]}</p></div>, 'error')
          }
      );
    }
  };

  const hideModal = () => {
    setShowModal(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (event, option) => {
    setPageSize(option.value);
  };


  return (
      <div>
        <Headeraccount />

        {navValue}

        <div className="tableWrapper">
          <div className="row p-40">
            <div className="col-md-12 col-sm-12">
              <h5 className="subtitle-large p-l-15">Add new software </h5>
              <br />
              <div className="row p-l-15">
                <div className="col-md-3 col-sm-12 col-xs-12 p-b">
                  <ThemeProvider mode="light" shape="round" density="high">
                    <TextBox
                        className="text-l"
                        name="SoftwareName"
                        value={softwareName}
                        placeholder={"Software Name"}
                        onChange={(e) => changeSoftwareName(e)}
                        id="select-software-name"
                        error={softwareNameError}
                    />
                  </ThemeProvider>
                </div>
                <div className="col-md-3 col-sm-12 col-xs-12 p-b">
                  <ThemeProvider mode="light" shape="round" density="high">
                    <Button
                        className="button-p"
                        onClick={addButton}
                        id="addNewSoftware"
                    >
                      Add
                    </Button>
                  </ThemeProvider>
                </div>
              </div>
              <br />
              <br />
              <h5 className="subtitle-large p-l-15">Add new file </h5>
              <br />
              <div id="supplyFamily">
                <div className="row p-l-15 align-items-end">
                  <div className="col-md-3 col-sm-12 col-xs-12 p-b d-flex align-items-start">
                    <ThemeProvider mode="light" shape="round" density="high">
                      <Select
                          clearIcon={false}
                          value={[selectedSoftware]}
                          placeholder={"Select Software Name"}
                          options={
                            softwareTable
                                ? softwareTable.map((e) => {
                                  return { value: e.name, id: e.id };
                                })
                                : []
                          }
                          onChange={(e) => selectSoftwareChange(e)}
                          id="select-software-name"
                      />
                    </ThemeProvider>
                  </div>
                  <div className="row p-l-25 p-r-35 p-b d-flex align-items-start">
                    {selectedSoftware && !uploadingStatus ? (
                        <div>
                          <ThemeProvider mode="light" shape="round" density="high">
                            <FilePicker
                                appearance="secondary"
                                label={selectedFile?.name || "Upload File"}
                                className="button-p"
                                id="file-picker-default"
                                accept=".zip"
                                onChange={onChangeFileHandler}
                                onClear={() => {
                                  setSignaturePickerError(false);
                                  setSignatureFileNameErrorText("");
                                  setPublicKeyPickerError(false);
                                  setPublicKeyFileNameErrorText("");
                                }}
                                error={filePickerError}
                                helperText={
                                  filePickerError ? softwareFileNameErrorText : ""
                                }
                                onClear={() => setSelectedFile("")}
                            />
                          </ThemeProvider>
                        </div>
                    ) : (
                        <ThemeProvider mode="light" shape="round" density="high">
                          <FilePicker
                              disabled={true}
                              appearance="secondary"
                              label="Upload File"
                              id="file-picker-default"
                              accept=".zip"
                              onChange={onChangeFileHandler}
                              options={
                                softwareTable
                                    ? softwareTable.map((e) => {
                                      return { value: e.signed };
                                    })
                                    : []
                              }
                          />
                        </ThemeProvider>
                    )}
                  </div>
                  <div className="col-md-3 col-sm-12 col-xs-12 p-b">
                    {selectedFile && (!hasSignature || (hasSignature && (signatureFile && publicKeyFile))) && !uploadingStatus ? (
                        <ThemeProvider mode="light" shape="round" density="high">
                          <Button
                              appearance="secondary"
                              className="button-p"
                              onClick={onFileUpload}
                              id="uploadNewSwFile"
                          >
                            Upload
                          </Button>
                        </ThemeProvider>
                    ) : (
                        <ThemeProvider mode="light" shape="round" density="high">
                          <Button
                              loading={spinnerLoadingStatus}
                              disabled={true}
                              appearance="secondary"
                              className="button-p"
                              onClick={onFileUpload}
                              id="uploadNewSwFile"
                          >
                            Upload
                          </Button>
                        </ThemeProvider>
                    )}
                  </div>
                </div>
                {selectedSoftware && !uploadingStatus && (
                    <div className={'checkBoxDiv p-l-15 pt-3'} id="signature-checkbox">
                      <Checkbox
                          checked={hasSignature}
                          label="Have Signature? click the checkbox"
                          onChange={onHasSignatureChange}
                      />
                      {hasSignature ? <div className={'row'}>
                        <div className="col-md-6 col-lg-3 col-xs-8 col-sm-12 m-b-25">
                          <ThemeProvider mode="light" shape="round" density="high">
                            <FilePicker
                                label={signatureFile?.name || "Upload Signature"}
                                id="signature-file-picker"
                                accept=".asc"
                                onChange={onChangeSignatureFile}
                                error={signaturePickerError}
                                onClear={() => {
                                  setSignatureFile("");
                                  setSignaturePickerError(false);
                                  setSignatureFileNameErrorText("");
                                }}
                                helperText={
                                  signaturePickerError ? signatureFileNameErrorText : ""
                                }
                            />
                          </ThemeProvider>
                        </div>
                        <div className="col-md-6 col-lg-3 col-xs-8 col-sm-12 m-b-25">
                          <ThemeProvider mode="light" shape="round" density="high">
                            <FilePicker
                                label={publicKeyFile?.name || "Upload Public Key"}
                                id="public-key-file-picker"
                                accept=".pub"
                                onChange={onChangePublicKey}
                                error={publicKeyPickerError}
                                onClear={() => {
                                  setPublicKeyFile("");
                                  setPublicKeyPickerError(false);
                                  setPublicKeyFileNameErrorText("");
                                }}
                                helperText={
                                  publicKeyPickerError ? publicKeyFileNameErrorText : ""
                                }
                            />
                          </ThemeProvider>
                        </div>
                      </div> : null}

                    </div>
                )}
                <br />
                <br />
                <div className="row p-l-15">
                  <h5 className="subtitle-large p-l-15">
                    Select Downloadable File
                  </h5>
                  <div className="col-md-12">
                    <br></br>
                    <Table
                        id="downloadableSoftwareTable"
                        loading={loading}
                        columnResize={true}
                        columns={[
                          {
                            id: "softwarename",
                            label: "SOFTWARE NAME",
                          },
                          {
                            id: "filename",
                            label: "FILE NAME",
                          },
                          {
                            id: "filesize",
                            label: "FILE SIZE",
                          },
                          {
                            id: "signed",
                            label: "Signed",
                          },
                          {
                            id: "deletefile",
                            label: ""
                          },
                        ]}
                        data={
                          softwareTable
                              ? softwareTable.map((data, i) => {
                                return {
                                  softwarename: data.name,
                                  filename: (
                                      <ThemeProvider
                                          mode="light"
                                          shape="round"
                                          density="high"
                                      >
                                        <Select
                                            value={fileSelectedDrop ? fileSelectedDrop : selectedSoftwareFileDrop[i]}
                                            placeholder={
                                                selectedSoftwareFileDrop[i] ||
                                                "Select File"
                                            }
                                            options={
                                              data.software
                                                  ? data.software.map((swfile) => {
                                                    return {
                                                      value: swfile.name,
                                                      id: swfile.id,
                                                      softwareId: data.id,
                                                      signed: swfile.public_key_fileName != null && swfile.signature_fileName != null,
                                                    };
                                                  })
                                                  : []
                                            }
                                            id={"select-usage"}
                                            clearIcon={false}
                                            onChange={(e) =>
                                                selectedSWFileDropChange(e, i)
                                            }
                                        />
                                      </ThemeProvider>
                                  ),

                                  filesize: displaySize(i),
                                  signed: displaySigned(i),
                                  deletefile: (
                                      <Button
                                          small={true}
                                          onClick={() => deleteFunction(data.id, i)}
                                          appearance="secondary"
                                      >
                                        {" "}
                                        Delete
                                      </Button>
                                  ),
                                };
                              }).slice(
                                  (currentPage - 1) * pageSize,
                                  (currentPage - 1) * pageSize + pageSize)
                              : null
                        }
                        pagination={{
                          currentPage: currentPage,
                          pageSizeOptions:
                              softwareTable.length <= 2
                                  ? [{ value: softwareTable.length }]
                                  : softwareTable.length < 5
                                      ? [{ value: 2 }, { value: softwareTable.length }]
                                      : softwareTable.length <= 8
                                          ? [
                                            { value: 2 },
                                            { value: 4 },
                                            { value: softwareTable.length },
                                          ]
                                          : softwareTable.length <= 9
                                              ? [
                                                { value: 2 },
                                                { value: 4 },
                                                { value: 8 },
                                                { value: softwareTable.length },
                                              ]
                                              : softwareTable.length <= 10
                                                  ? [
                                                    { value: 2 },
                                                    { value: 4 },
                                                    { value: 8 },
                                                    { value: softwareTable.length },
                                                  ]
                                                  : [
                                                    { value: 2 },
                                                    { value: 4 },
                                                    { value: 8 },
                                                    { value: 10 },
                                                    { value: softwareTable.length },
                                                  ],
                          onPageChange: handlePageChange,
                          onPageSizeChange: handlePageSizeChange,
                          totalItems: softwareTable.length,
                          pageSize: pageSize,
                        }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          <Modal show={showModal} onHide={() => hideModal}>
            {<Modal.Body>
              <div id="file-delete" className="modal-body">
                <p className="f-14">{delMsg[0]}</p>
                <p className="f-14">{delMsg[1]}</p>
              </div>
            </Modal.Body>
            }

            <div className="modal-footer justify-content-md-center b-t-0">
              {
                <ThemeProvider mode="light" shape="round" density="high">
                  <Button
                      id="CloseBtnCancel"
                      small={true}
                      data-dismiss="modal"
                      appearance="secondary"
                      className="spsaccount m-r-21"
                      onClick={hideModal}
                  >
                    Cancel
                  </Button>
                </ThemeProvider>
              }
              <br />

              <ThemeProvider mode="light" shape="round" density="high">
                <Button
                    loading={btnLoading}
                    id="CloseBtnDel "
                    small={true}
                    className="button-p"
                    data-dismiss="modal"
                    onClick={delFileFunc}
                >
                  OK
                </Button>
              </ThemeProvider>
            </div>
          </Modal>
        </div>
      </div>
  );
};

export default SWCatalogUpload;